"use client";

import { usePathname } from "next/navigation";

import { Header } from "@/app/_components/header";

export function AppHeader({ isLoggedIn = true }: { isLoggedIn?: boolean }) {
  const pathname = usePathname();
  const isProfilePage = pathname === "/profile";
  const isNotificationsPage = pathname === "/notifications";

  if (isProfilePage || isNotificationsPage) {
    return null;
  }

  return <Header isLoggedIn={isLoggedIn} />;
}
